const environment = process.env.VUE_APP_API_URL;
const siteUrl = process.env.VUE_APP_SITE_URL;
// const apiBaseUrl = VUE_APP_API_BASE_URL;
const apiBaseUrl = `${environment}/api/`;
const nodeEnv = process.env.NODE_ENV;
const adminUrl = process.env.VUE_APP_ADMIN_URL;
const stripeAPIKey = process.env.VUE_APP_STRIPE_API_KEY;
const mapApiKey = process.env.VUE_APP_TOM_TOM_API_KEY;
const mapStyleFile = process.env.VUE_APP_TOM_TOM_JSON_FILE;

function isNonLiveApiUrl(apiUrlValue) {
  if (!apiUrlValue) {
    return false;
  }

  const normalized = apiUrlValue.toString().trim().toLowerCase();
  const hostWithPort = normalized.replace(/^https?:\/\//, '').split('/')[0];
  if (!hostWithPort) {
    return false;
  }

  const host = hostWithPort.split(':')[0];

  if (host === 'localhost') {
    return true;
  }

  // IP address (e.g. local network testing / device testing)
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
    return true;
  }

  // Heuristic: treat explicitly-marked environments as non-live.
  return host.includes('octotest')
    || host.includes('staging')
    || host.includes('pmgdev')
    || host.includes('ngrok')
    || host.includes('sandbox')
    || host.includes('uat')
    || host.includes('test')
    || host.includes('dev');
}

function validateStripeKeyPrefix() {
  if (nodeEnv === 'test') {
    return;
  }

  if (!stripeAPIKey) {
    return;
  }

  const key = stripeAPIKey.toString().trim();
  const isLiveKey = key.startsWith('pk_live_');
  const isTestKey = key.startsWith('pk_test_');
  let apiUrlForValidation = environment;
  if (!apiUrlForValidation || !apiUrlForValidation.toString().trim()) {
    const proxyTarget = process.env.VUE_APP_API_PROXY_TARGET;
    if (proxyTarget && proxyTarget.toString().trim()) {
      apiUrlForValidation = proxyTarget;
    } else {
      try {
        if (typeof window !== 'undefined' && window.location && typeof window.location.origin === 'string') {
          apiUrlForValidation = window.location.origin;
        }
      } catch (e) {
        apiUrlForValidation = environment;
      }
    }
  }

  if (!apiUrlForValidation || !apiUrlForValidation.toString().trim()) {
    return;
  }

  const nonLiveApi = isNonLiveApiUrl(apiUrlForValidation);

  if (nonLiveApi && isLiveKey) {
    throw new Error(`Invalid Stripe publishable key: refusing to use pk_live_ against non-live API URL (${apiUrlForValidation}).`);
  }

  if (!nonLiveApi && isTestKey) {
    throw new Error(`Invalid Stripe publishable key: refusing to use pk_test_ against live API URL (${apiUrlForValidation}).`);
  }
}

validateStripeKeyPrefix();

export {
  environment, apiBaseUrl, adminUrl, stripeAPIKey, nodeEnv, siteUrl, mapApiKey, mapStyleFile,
};
